import Vue from 'vue';

const initialProposalEventBus = new Vue();

export default initialProposalEventBus;
